import React from "react";
import Lottie from "react-lottie";
import loader from "../Assets/Json/loaderJson.json";

const Loader = () => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: loader,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  return (
    <div className="loading-screen">
      <div className="lottie-container">
        <Lottie options={defaultOptions} height={70} width={70} />
      </div>
    </div>
  );
};

export default Loader;
